import { registerRootComponent } from 'expo'
import * as Sentry from '@sentry/react'
// import * as ScreenOrientation from 'expo-screen-orientation'
import { useFonts } from 'expo-font'
import { StatusBar } from 'expo-status-bar'
import { FONTS } from '~/const/assets'
import Main from '~/components/Main'

Sentry.init({
    dsn: 'https://5b512866ec0117190241bc1953cf5f5f@o4509139247104000.ingest.de.sentry.io/4509139248349264',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    // // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
})

export default function App() {
    const fonts = {}
    Object.keys(FONTS).forEach((font_name) => {
        fonts[font_name] = FONTS[font_name]
    })
    const [fonts_loaded] = useFonts(fonts)

    return (
        fonts_loaded && (
            <>
                <StatusBar hidden={true} />
                <Main />
            </>
        )
    )
}

registerRootComponent(App)

// try {
//     if (isIos() || isAndroid()) {
//         ScreenOrientation.lockAsync(
//             ScreenOrientation.OrientationLock.LANDSCAPE_LEFT
//         )
//     }
// } catch (e) {}

// document.addEventListener('visibilitychange', () => {
//     const state = document.visibilityState
//     console.log('visibilitychange:', state)
//     if (state === 'hidden') {
//         // your PWA is now in the background
//     }

//     if (state === 'visible') {
//         // your PWA is now in the foreground
//     }
// })
